

import { ApplicationConfig, APP_INITIALIZER } from '@angular/core';
import { provideRouter } from '@angular/router';
import { appRoutes } from './app.routes';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthorizationService } from './services/authorization.service';
import { DomainInitService } from './shared/services/domain-init.service';
import { loadingInterceptor } from './shared/interceptors/loader.interceptor';
import { authInterceptor } from './shared/interceptors/auth.interceptor';
import { SessionService } from './shared/services/session.service';
import { TranslateService } from './shared/services/translate.service';

function initAuth(auth: AuthorizationService) {
  return () => auth.initFromSession();
}

function initTranslate(translate: TranslateService) {
  return () => translate.load(localStorage.getItem('preferredLang') ?? 'it');
}

function initDomainState(domainInit: DomainInitService) {
  return () => domainInit.init();
}

function initSession(session: SessionService) {
  return () => session.watchExpiry();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(appRoutes),
    provideAnimations(),
    provideHttpClient(withInterceptors([loadingInterceptor, authInterceptor])),
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [AuthorizationService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initDomainState,
      deps: [DomainInitService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initSession,
      deps: [SessionService],
      multi: true
    },
    {
      provide: APP_INITIALIZER,
      useFactory: initTranslate,
      deps: [TranslateService],
      multi: true
    },
  ]
};
